module.exports = __webpack_public_path__ + "static/media/05-_DSC0327.2c51995a.jpg";